import { forwardRef } from 'react';

import type { A11y, ButtonMenuTheme, Classnames } from '@snowit/icetypes';

import Avatar from '../../Avatar/Avatar';
import BadgeNotify from '../../Badges/BadgeNotify/BadgeNotify';
import Icon from '../../Icon';

import cx from 'classnames';
import s from './ButtonMenu.module.scss';

export interface IButtonMenu {
  theme?: ButtonMenuTheme;
  user?: {
    name: string;
    surname: string;
    photo?: string;
  };
  notify: boolean;
  open: boolean;
  onClick: (...args: any[]) => void;
  pulse?: boolean;
  id?: string;
  classNames?: Classnames<'wrapper' | 'btn' | 'icon' | 'avatar'>;
  a11y?: A11y;
}

const ButtonMenu = forwardRef<HTMLButtonElement, IButtonMenu>((props, ref) => {
  const { theme = 'user', user, notify, open, onClick, id, classNames, a11y } = props;

  const renderBadge = () => {
    if (!notify) return null;
    return (
      <BadgeNotify className={s.badge} size={1} color={'var(--c-primary)'} pulse={props.pulse} />
    );
  };

  const renderIcon = () => {
    return (
      <Icon
        className={cx(s.iconBtn, classNames?.icon)}
        name={open ? 'close' : 'menu'}
        sizeV2={theme === 'icon' ? 1.25 : 1}
        a11y={{ hidden: true }}
        test={'user_menu'}
      />
    );
  };

  const renderAvatar = () => {
    if (theme !== 'user') return null;
    return <Avatar className={classNames?.avatar} user={user} test={'avatar_icon'} />;
  };

  return (
    <button
      ref={ref}
      className={cx(s.wrapper, classNames?.wrapper, { [s[theme]]: true })}
      id={id}
      type={'button'}
      onClick={onClick}
      aria-label={a11y?.label}
      aria-expanded={a11y?.expanded}
      aria-controls={a11y?.controls}
      aria-haspopup={a11y?.haspopup}
    >
      {renderBadge()}
      {renderIcon()}
      {renderAvatar()}
    </button>
  );
});

export default ButtonMenu;
